<h2>Glömt lösenord</h2>

@if (!reqSent) {
  <div class="content-wrapper">
    <p>
    Ange den e-postadress som är kopplad till det konto du vill återställa lösenord för.</p>
    <p>
      En återställningslänk skickas till den e-postadressen.
      Om du kommer på ditt lösenord i efterhand kommer du fortfarande in med det - även om du har begärt återställning.
    </p>
    <p>OBS! Länken går ut efter 30 minuter för att skydda ditt konto.</p>
    @if (email) {
      <form (ngSubmit)="sendResetRequest()">
        <mat-form-field>
          <input matInput [formControl]="email" name="email" placeholder="E-post" spellcheck="false" autocomplete="off">
        </mat-form-field>
        <button class="button" type="submit">Skicka</button>
      </form>
    }
    <button class="button" (click)="toLogin()">Tillbaka till logga in</button>
  </div>
}

@if (reqSent) {
  <div class="content-wrapper">
    <p>
      Vi har skickat ett mejl med en återställningslänk till adressen du angivit.
      Länken går ut efter 30 minuter för att skydda ditt konto.
    </p>
    <button class="button" (click)="toLogin()">Tillbaka till logga in</button>
  </div>
}